import { createSlice } from '@reduxjs/toolkit';

import type { CategoryKV } from '@/dtos/Category';
import axiosInstance from '@/plugins/axios';
import { createAppAsyncThunk } from '@/store/thunk';

interface CategoriesState {
  loading: boolean;
  all: CategoryKV[];
}

const initialState: CategoriesState = {
  loading: false,
  all: []
};

export const requestAllCategories = createAppAsyncThunk('categories/getAll', async () => {
  try {
    const response = await axiosInstance.get<undefined, CategoryKV[]>('/public/categories');
    return response;
  } catch {
    return;
  }
});

export const categoriesSlice = createSlice({
  name: 'categories',
  initialState,
  reducers: {
    resetCategories: (state) => {
      state.loading = false;
      state.all = [];
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(requestAllCategories.pending, (state) => {
        state.loading = true;
      })
      .addCase(requestAllCategories.rejected, (state) => {
        state.all = [];
        state.loading = false;
      })
      .addCase(requestAllCategories.fulfilled, (state, action) => {
        if (action.payload) {
          state.all = action.payload;
        }
        state.loading = false;
      });
  }
});

export const { resetCategories } = categoriesSlice.actions;
